import React, { useEffect } from "react";

const PdfViewer = ({ pdfUrl }) => {
  useEffect(() => {
    if (pdfUrl) {
      window.open(pdfUrl, "_blank");
    }
  }, [pdfUrl]);

  return null; // não precisa renderizar nada visível
};

export default PdfViewer;
